<template>
  <v-card flat max-width="800">
    <v-card-title> <h3 class="py-4 text-h6">¿Como te contactamos?</h3></v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row dense>


          <v-col cols="12">
            <v-text-field
                outlined
                :prepend-icon="dense ? null : 'badge'"
                name="name"
                v-model="form.name"
                :label="$t('delivery.order.labels.name')"
                :placeholder="$t('delivery.order.labels.name')"
                :error="hasInputErrors('name')"
                :error-messages="getInputErrors('name')"
                color="secondary"
                :rules="required"
                required class="required"
                @input="updateLastContact"
            ></v-text-field>
          </v-col>


          <v-col :cols="dense ? 12 : 12" >
            <v-text-field
                outlined
                :prepend-icon="dense ? null : 'phone'"
                name="phone"
                v-model="form.phone"
                :label="$t('delivery.order.labels.phone')"
                :placeholder="$t('delivery.order.labels.phone')"
                :error="hasInputErrors('phone')"
                :error-messages="getInputErrors('phone')"
                color="secondary"
                :rules="phoneRules"
                required class="required"
                @input="updateLastContact"
            ></v-text-field>
          </v-col>


          <v-col :cols="dense ? 12 : 12" >
            <v-text-field
                outlined
                :prepend-icon="dense ? null : 'email'"
                name="email"
                v-model="form.email"
                :label="$t('delivery.order.labels.email')"
                :placeholder="$t('delivery.order.labels.email')"
                :error="hasInputErrors('email')"
                :error-messages="getInputErrors('email')"
                color="secondary"
                :rules="emailRules"
                required
                :class="{'required':emailRequired}"
                @input="updateLastContact"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
                outlined
                :rows="dense ? 2 : 2"
                :prepend-icon="dense ? null : 'description'"
                name="observations"
                v-model="form.observations"
                :label="$t('delivery.order.labels.observations')"
                :placeholder="$t('delivery.order.labels.observations')"
                :error="hasInputErrors('observations')"
                :error-messages="getInputErrors('observations')"
                color="secondary"
                hide-details
                @input="updateLastContact"
            ></v-textarea>
          </v-col>

          <v-col v-if="nextButton"
                 cols="12"
                 class="text-right mt-2"
          >
            <submit-button
                text="common.next"
                @click="submitContact"
                :disabled="!this.isValid"
            ></submit-button>
          </v-col>

        </v-row>
      </v-form>
    </v-card-text>
  </v-card>

</template>

<script>
import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import {SubmitButton} from "@dracul/common-frontend"

export default {
  name: "CustomerContactForm",
  mixins: [InputErrorsByProps, RequiredRule],
  components: {SubmitButton},
  props: {
    nextButton: {type: Boolean, default: false},
    dense: {type: Boolean, default: false},
    emailRequired: {type: Boolean, default: false},
  },
  data() {
    return {
      submitDisabled: true,
      valid: false
    }
  },

  computed: {
    form: {
      get() {
        return this.$store.getters.orderSystem.order.contact
      },
      set(val) {
        this.$store.commit('orderContact', val)
      }
    },
    emailRules() {
      return [
        v => (!this.emailRequired || !!v) || this.$t('user.validation.required'),
        v => (v == "" || /.+@.+/.test(v) ) || this.$t('user.validation.emailFormat')
      ]
    },
    phoneRules() {
      return [
        v => !!v || this.$t('user.validation.required'),
        v => /^(\+)?[0-9]+$/i.test(v) || !v || this.$t('user.validation.number'),
        v => !v || v.length >= 8 || 'Minimo 8',
      ]
    },
    isValid() {
      return (this.valid && this.form.name != '' && (!this.emailRequired || this.form.email != '') && this.form.phone != '')
    }
  },
  methods: {
    updateLastContact(){
      this.$store.commit('lastContact', this.form)
    },
    submitContact() {
      if (this.isValid) {
        this.$emit('next')
      }
    }
  }
}
</script>

<style scoped>

</style>
